






















































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import firebase from 'firebase/app';
import 'firebase/database';
import OnFleetService from '../services/OnFleetService';
import moment from 'moment';
import ManualExport from './ManualExport.vue';
import OrderHelper from '../helpers/orderHelper';
import Constants from '../config/constants';

@Component({
  components: {ManualExport}
})
export default class Export extends Vue {
  private pagination: any = {
    sortBy: 'name',
    rowsPerPage: -1
  };

  private selected: any = [];
  private date = moment().toISOString();
  private deliveryDate = moment().toISOString();
  private menu = false;
  private menu2 = false;
  private dialog = false;
  private exporting = false;
  private exportCount = 0;
  private exportPercent = 0;
  private loading = false;
  private orders: any = {};
  private users: any = {};
  private items: any = [];
  private selectedItem: any = {};
  private headers: any = [
    {text: 'Name', value: 'name', align: 'left'},
    {text: 'Unit', value: 'unit'},
    {text: 'Address', value: 'address'},
    {text: 'Company', value: 'company'},
    {text: 'Location', value: 'location'},
    {text: 'Bags', value: 'quantity'},
    {text: 'Instructions', value: 'instructions'},
    {text: 'Status', value: 'status'},
  ];

  private dayGroups: any = {
    sun: ['mon', 'tue'],
    mon: ['mon', 'tue'],
    tue: ['wed', 'thu'],
    thu: ['fri', 'sat']
  };

  private mounted() {
    const day = moment(this.date).day();
    if (day === 3 || day === 6) {
      this.addDays(1);
    } else if (day === 5) {
      this.addDays(2);
    }
    this.loadOrders();
  }

  private allowedDates(val: any) {
    return [1, 2, 4, 0].includes(moment(val).day());
  }

  private loadOrders() {
    this.deliveryDate = this.date;
    if (!this.orders[this.yearWeek]) {
      const db = firebase.database();
      const orderRef = db.ref(`orders/${this.yearWeek}`);
      console.log('loading orders ', this.yearWeek);
      orderRef.once('value', (snapshot) => {
        console.log('loaded orders ', this.yearWeek);
        Vue.set(this.orders, this.yearWeek, snapshot.val());
      });
    }
  }

  private addDays(inc: number) {
    this.date = moment(this.date).add(inc, 'days').toISOString();
  }

  get day() {
    return moment(this.date).format('ddd').toLowerCase();
  }

  get deliveryDay() {
    return moment(this.deliveryDate).format('ddd').toLowerCase();
  }

  get weekOrder() {
    return this.orders[this.yearWeek];
  }

  get dayOrder() {
    const orderData: any = {};
    const days = this.dayGroups[this.day];
    const ordersInWeek = this.orders[this.yearWeek];
    // console.log('ordersInWeek', { yearWeek: this.yearWeek, ordersInWeek, days });
    for (const uid in this.weekOrder) {
      const usersOrder = ordersInWeek[uid];
      if (ordersInWeek.hasOwnProperty(uid) && usersOrder.meals) {
        const shippingDay = usersOrder.logistics && usersOrder.logistics[this.day];
        const status: any = shippingDay ? shippingDay.status : 'not exported';

        for (const day of days) {
          const meals: Array<{ quantity: number }> = usersOrder.meals[day];
          if (meals) {
            for (const meal of meals) {
              // FIXME: we are skipping the second day of meals - this should just be a boolean (hasMealsOnDays)
              if (meal.quantity > 0 && !orderData[uid]) {
                orderData[uid] = meals;
              }
            }
          }
        }

        if (orderData[uid]) {
          if (orderData[uid].status) {
            // FIXME: does this ever actually happen?
            console.warn('status was already set', {uid, orderData: orderData[uid]});
            orderData[uid].status = orderData[uid].status === 'exported' ? orderData[uid].status : status;
          } else {
            orderData[uid].status = status;
          }

        }
      }
    }
    // console.log('dayOrder', orderData);
    return orderData;
  }

  @Watch('dayOrder')
  private async onDayOrderChange(value: any, oldValue: any) {
    this.items = [];
    this.loading = true;
    this.users = {};
    await this.loadUsers();
    this.loadItems();
  }

  private async loadUsers() {
    await Promise.all(Object.keys(this.dayOrder).map(this.loadUser));
  }

  private async loadUser(key: any) {
    const db = firebase.database();
    // for (const key in this.dayOrder)
    {
      // if (this.dayOrder.hasOwnProperty(key))
      {
        console.log('loading user', key);
        const userRef = db.ref(`users/${key}`);
        const snapshot = await userRef.once('value');
        this.users[key] = snapshot.val();
        if (!this.users[key]) {
          console.log('error, could not find user', `users/${key}`);
          /** delete because the app iterates on users, we want this user skipped! */
          delete this.users[key];
          return;
        }
        this.users[key].status = this.dayOrder[key].status;
        this.users[key].quantity = this.dayOrder[key].total;
        if (this.users[key].company) {
          const company = this.companies.find((item: any) => item.id === this.users[key].company);
          if (company) {
            this.users[key].company = company.name;
            this.users[key].address = company.address;
            if (company.schedule) {
              this.users[key].schedule = company.schedule;
            }
          }
        }
      }
    }
  }

  private loadItems() {
    const items: any[] = [];
    for (const uid in this.users) {
      if (this.users.hasOwnProperty(uid)) {
        const item: {
          company: string;
          unit: string;
          completeBefore: number;
          completeAfter: number;
          location: any;
          instructions: any;
          status: any;
          uid: string;
          quantity: any;
          name: string, phone: any, address: string
        } = {
          unit: '',
          completeBefore: 0,
          completeAfter: 0,
          location: '',
          quantity: 0,
          uid: '',
          status: '',
          instructions: '',
          name: '',
          address: '',
          phone: '',
          company: ''
        };
        const user = this.users[uid];

        if (user.is_active === false && !user.show_meals) {
          continue;
        }

        item.uid = uid;
        item.name = `${user.first_name} ${user.last_name}`;
        item.phone = user.phone_number || Constants.dummyPhoneNumber;
        // item.phone = user.phone_number ? parseInt(user.phone_number.split(' ').join(''), 10).toString() || null : Constants.dummyPhoneNumber;
        item.address = user.address
            ? `${user.address.line1 || ''} ${user.address.city || ''} ${user.address.postal_code || ''}, Canada`
            : '';
        item.unit = user.address ? user.address.unit || '' : '';
        item.quantity = OrderHelper.getNumberOfBags(this.orders[this.yearWeek][uid], this.dayGroups[this.day], this.users[uid].meal_size);
        if (user.address && user.address.location) {
          item.location = user.address.location;
        } else if (user.company) {
          item.location = Constants.office;
        } else {
          item.location = Constants.home;
        }
        if (item.location === Constants.office && this.day === 'sun') {
          continue;
        }
        if (item.location === Constants.home && this.day === 'mon') {
          continue;
        }
        const bagSize = OrderHelper.getSizeOfBags(this.orders[this.yearWeek][uid], this.dayGroups[this.day], this.users[uid].meal_size);
        const bins = OrderHelper.getBins(this.orders[this.yearWeek][uid], this.dayGroups[this.day]);

        item.company = user.company || '';
        item.instructions = user.delivery_instruction;
        if (bins && bins.length > 0) {
          function extractLetterAndNumber(s: string) {
            return s && (s[0] + s.split('-')[1]);
          }

          const binText = `[${bins.map(extractLetterAndNumber).join(', ')}]  \n`;
          item.instructions = binText + item.instructions;
        }

        if (bagSize === Constants.largeBagSize) {
          item.instructions = `${item.instructions} - large bags`;
        }
        item.status = this.dayOrder[uid].status;
        items.push(item);
      }
    }
    this.items = items;
    this.loading = false;
  }

  private toggleAll() {
    if (this.selected.length) {
      this.selected = [];
    } else {
      this.selected = this.items.slice();
    }
  }

  private changeSort(column: any) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
  }

  private async createTask() {
    this.exporting = true;
    this.exportCount = 0;
    this.exportPercent = 0;
    const db = firebase.database();
    for (const item of this.selected) {
      const orderStatusRef = `orders/${this.deliveryYearWeek}/${item.uid}/logistics/${this.day}`;
      const userRef = db.ref(`${orderStatusRef}/status`);
      const user = this.users[item.uid];
      let timeBefore = item.location === 'home' ? Constants.endOfHomeDeliveryTime : Constants.endOfOfficeDeliveryTime;
      let timeAfter = item.location === 'home' ? Constants.startOfHomeDeliveryTime : Constants.startOfOfficeDeliveryTime;
      if (user.schedule && user.schedule[this.deliveryDay]) {
        timeBefore = user.schedule[this.deliveryDay].time_before || timeBefore;
        timeAfter = user.schedule[this.deliveryDay].time_after || timeAfter;
      }
      try {
        const recipient: any = {
          name: item.name
        };
        if (item.phone) {
          recipient.phone = item.phone;
        }
        /**
         * save a reference to the order in onfleet to make it easier
         * to reference back when looking up an order
         * https://docs.onfleet.com/reference#the-metadata-object
         */
        const metadata = [
          {
            name: 'order_reference',
            value: `${orderStatusRef}`,
            type: 'string',
            visibility: [
              'api'
            ]
          }
        ];

        const response = await OnFleetService.createTask({
          destination: {
            address: {
              unparsed: item.address,
              apartment: item.unit
            }
          },
          metadata,
          recipients: [recipient],
          recipientName: recipient.name,
          recipientNotes: recipient.notes,
          quantity: item.quantity,
          notes: item.instructions,
          completeBefore: moment(`${this.parseDate(this.deliveryDate)} ${timeBefore}`).valueOf(),
          completeAfter: moment(`${this.parseDate(this.deliveryDate)} ${timeAfter}`).valueOf()
        });
        await userRef.set('exported');
        item.status = 'exported';
      } catch (e) {
        await userRef.set('error');
        item.status = 'error';
      } finally {
        this.exportCount++;
        this.exportPercent += 100 / this.items.length;
      }
    }
    this.exporting = false;
  }

  private getCompany(id: string) {
    this.companies.find((item: any) => item.id === id);
  }

  private parseDate(date: any) {
    return moment(date).format('YYYY-MM-DD');
  }

  private parseReadableDate(date: any) {
    return moment(date).format('MMMM Do');
  }

  private showDialog(item: any) {
    this.selectedItem = item;
    this.dialog = true;
  }

  get companies() {
    return this.$store.getters.getCompanies;
  }

  get isMonday() {
    return moment(this.date).day() === 1;
  }

  get isFriday() {
    return moment(this.date).day() === 5;
  }

  get yearWeek() {
    // const year = moment(this.date).year();
    // const week = moment(this.date).week();
    // return `${year}_${week}`;
    return moment(this.date).format('gggg_w');
  }

  get deliveryYearWeek() {
    return moment(this.deliveryDate).format('gggg_w');
    // const year = moment(this.deliveryDate).year();
    // const week = moment(this.deliveryDate).week();
    // return `${year}_${week}`;
  }
}
